import { ChainedSchema } from '../general/ChainedSchema';
import { runtime } from '../../../../classes/runtime/Runtime';
import { deserializeAsAction } from '../middle/deserializeAsAction';
class SerializrType_legacy extends ChainedSchema {
    options;
    constructor(propSchema, options) {
        super(propSchema);
        this.options = options;
    }
    serializer(context) {
        return this.parentSchema.serializer(context);
    }
    deserializer(context) {
        if (!runtime.runtimePermissions.hasEditFunctionality) {
            return Symbol.for('do_not_assign');
        }
        return deserializeAsAction(this.parentSchema).deserializer(context);
    }
}
export function legacy(propSchema, options = {}) {
    return new SerializrType_legacy(propSchema, options);
}
